var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#E21B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9329 11.1452L14.3716 5.58398L5.86914 14.3993L11.3741 19.9043C15.8732 19.2855 19.4163 15.6759 19.9329 11.1452Z",
    fill: "#C40606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.843 14.5128C13.643 14.5128 13.4433 14.4365 13.2905 14.284L5.71922 6.71246C5.41391 6.40715 5.41391 5.91277 5.71922 5.60777C6.02453 5.30277 6.5189 5.30246 6.8239 5.60777L14.3955 13.1793C14.7008 13.4846 14.7008 13.979 14.3955 14.284C14.2426 14.4365 14.043 14.5128 13.843 14.5128Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27123 14.5129C6.07123 14.5129 5.87154 14.4366 5.71873 14.2841C5.41342 13.9788 5.41342 13.4845 5.71873 13.1795L13.2903 5.60789C13.5956 5.30258 14.09 5.30258 14.395 5.60789C14.7 5.9132 14.7003 6.40758 14.395 6.71258L6.82373 14.2841C6.67123 14.4366 6.47123 14.5129 6.27123 14.5129Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleIcon);
export default __webpack_public_path__ + "static/media/CloseCircleIcon.f14c4ed7.svg";
export { ForwardRef as ReactComponent };